// extracted by mini-css-extract-plugin
module.exports = {"categoriesList":"categoriesList_categoriesList__WCX_3"};